<template>
    <div class="page">
        <div class="userInfo">
            <img src="@/assets/wen/bj.png" class="bjimg" />
            <div class="logo">
                <img src="@/assets/wen/logo2.png" />
            </div>
            <div class="title">账号信息</div>
            <div class="user-item">
                <div class="label">昵称：</div>
                <div class="value" style="color: rgb(67, 125, 224);" v-if="myNikeName && myNikeName.length>0" >{{ myNikeName }}</div>
                <div class="value" style="color: rgb(67, 125, 224);" v-else @click="login">请登录</div>
            </div>
            <div class="user-item">
                <div class="label">手机号：</div>
                <div class="value">{{ myLoginPhone }}</div>
            </div>
        </div>
        <div style="background: #fff;padding-bottom: 20px;">
            <div class="order" @click="toSelectOrder">
                <div class="main">
                    <div class="top">
                        <img src="@/assets/wen/order.png" alt="">
                        <div class="order-top-title">我的订单</div>
                        <div class="order-top-allOrder">
                            全部订单
                            <van-icon name="arrow" />
                        </div>
                    </div>
                    <div class="orders">
                        <div class="order-item">
                            <img src="@/assets/wen/dfh.png" alt="" style="width: 27px;">
                            <div class="order-item-text">待发货</div>
                        </div>
                        <div class="order-item">
                            <img src="@/assets/wen/dsh.png" alt="" style="width: 27px;">
                            <div class="order-item-text">待收货</div>
                        </div>
                        <div class="order-item">
                            <img src="@/assets/wen/shjj.png" alt="" style="width: 27px;">
                            <div class="order-item-text">审核拒绝</div>
                        </div>
                        <div class="order-item">
                            <img src="@/assets/wen/ywc.png" alt="" style="width: 27px;">
                            <div class="order-item-text">已完成</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="we">
            <div class="main">
                <div class="we-top">
                    <img src="@/assets/wen/we.png" alt="" style="width: 36px;">
                    <div class="we-top-title">关于我们</div>
                </div>
                <div class="we-img">
                    <img src="@/assets/wen/logo4.png" alt="">
                </div>
                <div class="we-info">
                    从2019年至今，我们始终坚信：没有最好，只有更好。时光淬炼初心，每一份信任都让我们更懂：真诚，是超越交易的心意；陪伴，是对价值最深的诠释。
                    未来，这份承诺依旧——您需要的，永远是我们全力以赴的答案。
                </div>
            </div>
            
            <div class="userfeedback" @click="toOut()">
                <span style="margin-left: 77px;"  >注销登录</span>
            </div>


            <div class="copyRight" @click="goIntroduction">
                <div style="text-align: center;margin:14px 0;">深圳市雁云信息技术有限公司</div>
                <div style="text-align: center;margin-bottom:14px;">地址：深圳市龙华区民治街道民治社区1970科技园3栋201</div>
                <div style="text-align: center;margin-bottom:14px;">备案号：粤ICP备19128032号-1</div>
            </div>


        </div>
        <div class="f-tab">
            <van-tabbar v-model="active" @change="onChange">
                <van-tabbar-item icon="home-o">首页</van-tabbar-item>
                <van-tabbar-item icon="browsing-history-o">官网</van-tabbar-item>
                <van-tabbar-item icon="service-o">客服</van-tabbar-item>
                <van-tabbar-item icon="friends-o">我的</van-tabbar-item>
            </van-tabbar>
        </div>

        <van-popup v-model="show" round position="bottom" :style="{ height: '50%' }" closeable>
            <div class="title-name">扫码联系客服</div>
            <div class="kefu-img">
                <img src="@/assets/kefu/zhu.jpg" alt="">
            </div>
        </van-popup>

    </div>
</template>
<script>
import { Toast, Dialog } from 'vant';
import { wxRequest } from '@/api/user'
export default {
    data() {
        return {
            myNikeName:localStorage.getItem('myNikeName'),
            myLoginPhone:'**************',

            active: 3,
            show: false,
        }
    },
    created(){
        var loginPhone =localStorage.getItem('myLoginPhone');
        if(loginPhone){
            this.myLoginPhone=loginPhone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
        }
    },
    methods: {
        toSelectOrder() {
            var loginPhone = localStorage.getItem('myLoginPhone');
            if (loginPhone && loginPhone.length > 5) {
                this.$router.push({ path: '/ydai/selectOrder' });
            } else {
                Dialog.confirm({
                    title: "绑定提示",
                    message: "请先绑定手机号后，再来进行查询操作",
                }).then(() => {
                }).catch(() => { });
                return;
            }
        },

        goIntroduction() {
            window.location.href = 'https://beian.miit.gov.cn/'
        },

        toOut() {
            var loginPhone = localStorage.getItem('myLoginPhone');
            if (loginPhone && loginPhone.length > 5) {
                Dialog.confirm({
                    title: "温馨提示",
                    message: "确定要进行注销手机号操作吗？ ",
                }).then(() => {
                    localStorage.removeItem('myLoginPhone')
                    Toast.fail('注销成功！');
                    this.loginText = "登录/注册";
                }).catch(() => { });
            } else {
                Toast.fail('未查询到注册信息！');
            }
        },


        onChange(data) {
            console.log(data)
            if (data === 1) {
                window.open('http://www.szyanyun.com', '_blank');
            } else if (data === 2) {
                this.show = true
            } else if (data === 0) {
                this.$router.push({ path: '/wen/home' });
            }
        },
        login() {
            this.$router.push({ path: '/wen/login' });
        }
    }
}
</script>
<style lang="less" scoped>
.page {
    background: #f1f1f1;
    padding-bottom: 20px;

    .userInfo {
        background: #fff;
        padding: 36px 18px 18px 18px;
        position: relative;

        .bjimg {
            position: absolute;
            width: 380px;
            right: 0;
            top: 0;
            opacity: .7;
            z-index: 1;
        }

        .logo {
            border-radius: 36px;
            width: 73px;
            height: 73px;
            overflow: hidden;
            position: relative;
            margin-bottom: 18px;
            z-index: 3;

            img {
                width: 73px;
                height: 73px;
            }
        }

        .title {
            font-size: 20px;
            font-family: Medium, sans-serif;
            margin-bottom: 18px;
            display: flex;
            color: #111517;
            align-items: center;
        }

        .user-item {
            display: flex;
            font-size: 18px;
            margin-bottom: 9px;
            z-index: 999;
            position: relative;

            .label {
                color: #a2a7ad;
            }

            .value {}
        }
    }

    .order {
        height: 302px;
        margin: 0px 18px 0px 18px;
        background-color: #f2f3f5;
        border-radius: 20px;

        .main {
            padding: 27px;

            .top {
                display: flex;
                align-items: center;
                position: relative;

                img {
                    width: 36px;
                }

                .order-top-title {
                    font-size: 20px;
                    font-family: Medium, sans-serif;
                    margin-left: 13px;
                    color: #111517;
                }

                .order-top-allOrder {
                    position: absolute;
                    right: 0px;
                    color: #a2a7ad;
                    font-size: 16px;
                }
            }

            .orders {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                text-align: center;

                .order-item {
                    width: 47%;
                    background: #fff;
                    border-radius: 9px 9px 9px 9px;
                    margin-top: 18px;
                    padding: 17px 0;
                    position: relative;

                    .order-item-text {
                        color: #a2a7ad;
                        font-size: 16px;
                        margin-top: 4px;
                    }
                }
            }
        }
    }

    .we {
        padding: 0 18px 36px 18px;
        background: #f2f3f5;
        margin-top: 20px;

        .main {
            padding: 27px;
            background: #fff;
            border-radius: 20px;
            height: 400px;

            .we-top {
                display: flex;
                align-items: center;
                position: relative;

                /* margin-bottom: 27px; */
                .we-top-title {
                    font-size: 20px;
                    font-family: Medium, sans-serif;
                    margin-left: 13px;
                }

            }

            .we-img {
                img {
                    width: 100%;
                }
            }

            .we-info {
                color: #6f7378;
                text-indent: 1em;
                position: absolute;
                left: 0px;
                bottom: -67px;
                padding: 0 44px;
                font-size: 16px;
                line-height: 1.8;
            }
        }

        .userfeedback {
            font-size: 18px;
            font-family: Medium, sans-serif;
            height: 91px;
            line-height: 91px;
            text-align: left;
            padding: 9px 0;
            background-image: url('~@/assets/wen/yjfk.png');
            background-size: 100%;
            background-position: 50%;
            background-repeat: no-repeat;
        }
    }

}

.title-name {
    text-align: center;
    font-size: 20px;
    margin-top: 30px;
}

.kefu-img {
    width: 260px;
    height: 340px;
    margin: 20px auto;

    img {
        width: 100%;
        height: 100%;
        border-radius: 5px;
    }
}</style>